
export { SsuBalance } from "/home/runner/work/capsicum/capsicum/libs/features/wallet/web/src/ui/ssuBalance/ssuBalance.tsx"